// src/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://ebay-api-920776443733.europe-west1.run.app/', // Change to your backend URL
});

export default api;
